import { Dispatch, SetStateAction } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Row, TwoColGrid } from "../../../components/Layout/Layout";
import LoadingSpinner from "../../../ui-lib/components/Loading/LoadingSpinner";
import {
  ITreeData,
  CustomDropdown,
} from "../../../ui-lib/components/Hierarchy/CustomTreeDropdown/CustomDropdown";
import { IItemProp } from "../../../ui-lib/components/Dropdown/DropdownItem";
import Dropdown from "../../../ui-lib/components/Dropdown/Dropdown";

const OrganisationFields = ({
  adminType,
  organizationId,
  sellersArc,
  setSellersArc,
  alarmRes,
  customerId,
  publicResponceCenter,
  isLoading,
  isArcLoading,
  setSellerId,
  setCustomerId,
  setArcId,
}: {
  adminType: string;
  organizationId?: number;
  sellersArc?: IItemProp[];
  alarmRes: IItemProp[];
  customerId?: number;
  publicResponceCenter?: boolean;
  isLoading?: boolean;
  isArcLoading?: boolean;
  setSellersArc: Dispatch<SetStateAction<IItemProp[]>>;
  setSellerId: Dispatch<SetStateAction<number | undefined>>;
  setCustomerId: Dispatch<SetStateAction<number | undefined>>;
  setArcId: Dispatch<SetStateAction<number | undefined>>;
}) => {
  const { t } = useTranslation();
  const {
    trigger,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Row align="start" type="left">
      <TwoColGrid>
        {!publicResponceCenter && (
          <>
            {adminType === "seller" && (
              <Controller
                name="sellerId"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Dropdown
                    required
                    withFilter
                    maxVisible={8}
                    title={t("Common:belongs_to")}
                    disabled={!sellersArc || sellersArc.length < 2}
                    selectedItem={sellersArc?.find((item) => item.isSelected)}
                    placeholder={t("Administrator:seller_placeholder")}
                    items={sellersArc || []}
                    onSelectItem={(value?: IItemProp) => {
                      if (!value?.id) return;
                      field.onChange(value?.id as number);
                      setSellerId(value?.id as number);
                      setSellersArc(
                        sellersArc?.map((item) => ({
                          ...item,
                          isSelected: item.id === value?.id,
                        })) || []
                      );
                      trigger(field.name);
                    }}
                    validationError={
                      errors?.sellerId && t("Errors:input_field_required")
                    }
                  />
                )}
              />
            )}
            {(adminType === "admin" || adminType === "respondent") &&
              !publicResponceCenter && (
                <Controller
                  name="organizationId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) =>
                    isLoading ? (
                      <LoadingSpinner size={38} />
                    ) : (
                      <CustomDropdown
                        fullWidth
                        required
                        selectionMode="single"
                        label={
                          adminType === "admin"
                            ? t("Common:belongs_to")
                            : t("Common:organisation")
                        }
                        customerFilter={{
                          customers:
                            organizationId?.toString() ??
                            customerId?.toString(),
                        }}
                        placeholder={t("Common:select_organisation")}
                        onSelectSignle={(value?: ITreeData) => {
                          if (!value?.key) return;
                          field.onChange(value?.key as number);
                          setCustomerId(value?.key as number);
                          trigger(field.name);
                        }}
                        validationError={
                          errors?.organizationId &&
                          t("Errors:input_field_required")
                        }
                        parentId={organizationId?.toString()}
                      />
                    )
                  }
                />
              )}
          </>
        )}
        {adminType === "respondent" && (
          <Controller
            name="responseCenterId"
            control={control}
            rules={{ required: true }}
            render={({ field }) =>
              isLoading ? (
                <LoadingSpinner size={38} />
              ) : (
                <Dropdown
                  required
                  withFilter
                  maxVisible={8}
                  title={t("Common:belongs_to")}
                  placeholder={t("Common:select_alarm_reception")}
                  items={alarmRes}
                  disabled={
                    (!customerId && !publicResponceCenter) ||
                    !alarmRes.length ||
                    isArcLoading
                  }
                  selectedItem={alarmRes.find(
                    (item: IItemProp) => item.isSelected
                  )}
                  onSelectItem={(item?: IItemProp) => {
                    if (item) {
                      field.onChange(item.id);
                      setArcId(item.id as number);
                    }
                  }}
                  validationError={
                    errors?.responseCenterId && t("Errors:input_field_required")
                  }
                />
              )
            }
          />
        )}
      </TwoColGrid>
    </Row>
  );
};

export default OrganisationFields;
